import React from 'react';

const hotelImages = [
	{
		id: 1,
		title: 'Deluxe Room',
		description: 'A warm home away from home, offering comfort and luxury.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482193/IMG-20250516-WA0121_chz1bh.jpg',
	},
	{
		id: 2,
		title: 'Conference Lounge',
		description: 'Relax in our stylish and comfortable lounge area.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482199/IMG-20250516-WA0137_rpnxt5.jpg',
	},
	{
		id: 3,
		title: 'Modern Suite',
		description: 'Enjoy luxury and comfort in our modern suites.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482197/IMG-20250516-WA0129_yev0te.jpg',
	},
	{
		id: 4,
		title: 'Luxury Suites',
		description: 'Experience unparalleled comfort in our premium suites.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482194/IMG-20250516-WA0122_nlspns.jpg',
	},
	{
		id: 5,
		title: 'Luxurious Suite',
		description: 'Luxuriate in our spacious and elegant suite.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482195/IMG-20250516-WA0126_dxqtzi.jpg',
	},
	{
		id: 6,
		title: '',
		description: '',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482195/IMG-20250516-WA0127_bnh6vl.jpg',
	},
	{
		id: 7,
		title: 'Serene environment',
		description: 'Relax and unwind in our serene environment.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482198/IMG-20250516-WA0135_e0wx5a.jpg',
	},
	{
		id: 8,
		title: 'Security',
		description: 'Ensuring your safety and peace of mind during your stay.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482200/IMG-20250516-WA0140_boui9l.jpg',
	},
	{
		id: 9,
		title: '',
		description: '',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482200/IMG-20250516-WA0141_odqwzq.jpg',
	},
	{
		id: 10,
		title: 'Premium Suite',
		description: 'Experience luxury in our premium suite.',
		image: 'https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482197/IMG-20250516-WA0132_kknbie.jpg',
	},
];

export default function Hotels() {
	return (
		<div className="container mx-auto px-4 py-16 mt-8">
			<h2 className="text-4xl font-bold text-left mb-12 mt-12">
				Dari Hotel: Premium Hospitality Experiences
			</h2>

			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				{hotelImages.map((item) => (
					<div
						key={item.id}
						className={`relative group overflow-hidden rounded-xl shadow-lg ${
							item.id === 1 ? 'md:col-span-3 lg:col-span-1' : ''
						}`}
						style={{ height: item.id === 1 ? '500px' : '400px' }}
					>
						<div
							className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
							style={{ backgroundImage: `url(${item.image})` }}
						/>
						<div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
						<div className="absolute inset-0 p-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end">
							<h3 className="text-2xl font-bold mb-2">{item.title}</h3>
							<p className="text-sm mb-2">{item.description}</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
